import React from 'react'
import ReactDOM from 'react-dom';

import {takeLeading} from 'redux-saga/effects';
import {put, select} from 'redux-saga/effects'
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import qs from 'qs';
import axios from '../../services/axios-client';
import moment from 'moment';

export function* getGroups({week, year}) {
    try {
        yield put(actions.getGroupsSucceeded(null));
        const companyKey = yield select(state => state.auth.companyKey);
        const userToken = yield select(state => state.auth.userToken);
        const shopID = yield select(state => state.companies.shopId);
        const { employees, services, objects } = yield select(state => state.companies.activeFilters);
        const { neededDate } = yield select(state => state.groups);

        const data = {
            'shop_id': shopID,
            'weekOfYear': week,
            'year': year,
            employees,
            services,
            objects,
            neededDate,
        };

        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/booking/product/group/available-time/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken,
            },
        });

        const {slots} = response.data.result;
        const days = Object.keys(slots).map(key => {
            const date = moment()
                .locale('en')
                .isoWeekYear(year)
                .isoWeek(week)
                .isoWeekday(key)
                .startOf('day');

            return {
                date,
                groups: slots[key]
            };
        });

        yield put(actions.getGroupsSucceeded(days, week, year))
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export const watchGroups = [
    takeLeading(actionTypes.GET_GROUPS, getGroups),
];
